import mutationTypes from './types/mutation.types';
import { stateLoader } from './state';

const mutations = {
  [mutationTypes.SET_FILTER](state, payload) {
    state.filter = payload;
  },
  [mutationTypes.SET_ACADEMIC_YEAR](state, payload) {
    state.catalog.academicYears = payload;
  },
  [mutationTypes.SET_MONTH](state, payload) {
    state.catalog.months = payload;
  },
  [mutationTypes.SET_SERVICE_LOCATION](state, payload) {
    state.catalog.serviceLocations = payload;
  },
  [mutationTypes.SET_SPECIALIST](state, payload) {
    state.catalog.specialists = payload;
  },
  [mutationTypes.SET_ACTIVITY](state, payload) {
    state.catalog.activities = payload;
  },
  [mutationTypes.SET_CENTER](state, payload) {
    state.catalog.centers = payload;
  },
  [mutationTypes.SET_PROVIDER](state, payload) {
    state.catalog.providers = payload;
  },
  [mutationTypes.SET_FINALIZED_BILLING_STATUS](state, payload) {
    state.finilazedBillingStatus = payload;
  },
  [mutationTypes.SET_SEARCH_CONSULTING](state, payload) {
    state.trainingSearchResults = {
      ...state.trainingSearchResults,
      data: payload.data,
      pagination: {
        count: payload.count,
        currentPage: payload.currentPage,
        pageCount: payload.pageCount,
        totalItemCount: payload.totalItemCount,
      },
    };
  },
  [mutationTypes.SET_DISPOSE](state) {
    Object.assign(state, stateLoader());
  },
};

export default mutations;
